import TutorialDialog from './TutorialDialog';

export default TutorialDialog;
